import { render, staticRenderFns } from "./default-page-layout.vue?vue&type=template&id=7fc5f204&"
import script from "./default-page-layout.vue?vue&type=script&lang=js&"
export * from "./default-page-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports